module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-l2/assessment-l2.component.css
// module id = ./src/app/assessment-l2/assessment-l2.component.css
// module chunks = main